import { Controller } from '@hotwired/stimulus';
import { accepts, rejectsAll } from 'src/lib/cmp_cookies';

export default class extends Controller {
  static targets = ['rolex', 'analytics'];

  clickSave(e) {
    e.preventDefault();

    accepts({
      rolex: this.rolexTarget.checked,
      analytics: this.analyticsTarget.checked,
    });

    this.element.dispatchEvent(new Event('hide'));
  }

  clickAcceptAll(e) {
    e.preventDefault();

    this.rolexTarget.checked = true;
    this.analyticsTarget.checked = true;

    accepts({ all: true });
    this.element.dispatchEvent(new Event('hide'));
  }

  clickRejectAll(e) {
    e.preventDefault();

    this.rolexTarget.checked = false;
    this.analyticsTarget.checked = false;

    rejectsAll();
    this.element.dispatchEvent(new Event('hide'));
  }
}
